<template>
    <div class="presenter-product-container" :style="container" >
      <div class="product">
        <div class="frame" :style="frame">
          <div class="matte" :style="matte">
            <product :product="product" :dblClickActive="false"/>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Product from '@/components/designer/Product.vue'
export default {
  name: 'PresenterProduct',
  components: {
    Product,
  },
  props: {
    product: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
    }
  },
  methods: {
    
  },
  computed: {
    pixelPerUnit() {
      return this.$store.getters.pixelPerUnit
    },
    backgroundImage() {
      return this.$store.getters.backgroundImage
    },
    frameWidth() {
      return Math.floor(this.product.frame.frameWidth*this.pixelPerUnit)
    },
    matteWidth() {
      return Math.floor(this.product.matte.size*this.pixelPerUnit)
    },
    position() {
      let top = this.backgroundImage.y + this.backgroundImage.height*this.product.relativeY
      let left = this.backgroundImage.x + this.backgroundImage.width*this.product.relativeX

      if(this.product.frame != '') {
        top -= this.matteWidth + this.frameWidth
        left -= this.matteWidth + this.frameWidth
      }

      return {
        top: Math.floor(top),
        left: Math.floor(left),
      }
    },
    productSize() {
      return { 
        width: Math.floor(this.product.productSize[0]*this.pixelPerUnit), 
        height: Math.floor(this.product.productSize[1]*this.pixelPerUnit)
      }
    },
    containerSize() {
      let w = this.productSize.width
      let h = this.productSize.height

      if(this.product.frame != '') {
        w += this.matteWidth*2 + this.frameWidth*2
        h += this.matteWidth*2 + this.frameWidth*2
      }
      return {
        width: w,
        height: h
      }
    },
    container() {
      return {
        top: this.position.top+'px',
        left: this.position.left+'px',
        width: this.containerSize.width+'px',
        height: this.containerSize.height+'px'
      }
    },
    frame() {
      let s = { borderWidth: '0px' }
      if(this.product.frame && this.product.frame.src != '' && this.product.frame.frameWidth > 0) {
        s = { 
          borderImageSource: 'url('+this.product.frame.src+')', // for http:// links
          borderImageSlice: this.product.frame.borderImageSlice,
          borderWidth: this.frameWidth+'px',
          width: Math.floor(this.productSize.width + this.matteWidth*2) + 'px',
          height: Math.floor(this.productSize.height + this.matteWidth*2) + 'px'
        }
      }
      if(this.product.frame.src != 'frame.png' && (this.product.frame.shadow !== false || this.product.frame.src == '' || this.product.frame.frameWidth == 0)) {
        s.boxShadow = '1px 1px 5px rgba(0, 0, 0, 0.5)'
      }
      return s
    },
    matte() {
      if(this.product.frame) {
        return { 
          padding: this.matteWidth+'px',
          backgroundColor: this.product.matte.color
        }
      }
      return {}
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.presenter-product-container {
  position: absolute;
  top:0;
  left:0;
  will-change: transform;
}
.frame {
  border-image-slice: 120; 
  border-style: outset;
  display: block;
}
.matte {
  background-color: white;
  box-shadow: inset 0 0 5px #000000;
  position: relative;
}

.fab {
  position: absolute;
  top: -40px;
  right: -40px;
  background-color: white;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  cursor: pointer;
  transition: transform 0.1s;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);

  .fab-item {
    position: absolute;
    width: 30px;
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
    cursor: pointer;
    background-color: $primary;
    color: white;
    animation: fab-appear 0.15s ease-out;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  }

  .copy {
    top: -20px;
    left: -40px;
    // animation-delay: 0;
  }
  .delete {
    top: -40px;
    left: 0px;
    // animation-delay: 50ms;
  }
  .frame-icon {
    top: -20px;
    left: 40px;
    // animation-delay: 100ms;
  }
  .shadow {
    top: 25px;
    left: 35px;
    // animation-delay: 150ms;
  }
}

.rotate {
  transform: rotate(90deg);
  transition: transform 0.1s;
}

.product-size {
  position: absolute;
  bottom: -30px;
  left: 0;
  color: rgba(0, 0, 0, 0.8);
  user-select: none;
}

</style>